import classNames from 'classnames';

import StyledBtn from './styles';

const Button = ({
    children, className = '', loading, ...props
}) => (
    <StyledBtn
        {...props}
        className={classNames(className, { loading })}
        disabled={loading || props?.disabled || false}
    >
        <div className="content">
            {children}
        </div>
    </StyledBtn>
);

export default Button;
